import React, { memo } from 'react';
import UnifiedPrintModal from '@/components/Print/UnifiedPrintModal';

interface PrintBillPreviewModalProps {
  open: boolean;
  invoice: any;
  onClose: () => void;
}

function PrintBillPreviewModal({ 
  open, 
  invoice,
  onClose
}: PrintBillPreviewModalProps) {

  return (
    <UnifiedPrintModal
      open={open}
      onClose={onClose}
      type="invoice"
      data={invoice}
      title="Invoice Print Preview"
    />
  );
}

export default memo(PrintBillPreviewModal); 